import styled from 'styled-components';

// Import ThumbnailScroller from conversation for extending
import { ThumbnailScroller } from '../../Conversation/styles';

// Scene-specific styles

export const Thumbnails = styled(ThumbnailScroller)`
	// layout
	margin-top: 8px;
	margin-left: 4px;
	margin-right: 4px;
`;
